import { createRoot } from "react-dom/client";
import * as fonts from "~prad/Styling/AvtalatFonts";
import * as textCodeService from "~base/Services/TextCodeService";
import MainApp from "./MainApp";

textCodeService.initialize(["sv-SE"], ["VisiFinance.*", "Avtalat.*"]);
fonts.attachCss();

createRoot(document.getElementById("react-main-root")!).render(<MainApp />);
